import { Tag } from "antd";
import * as APITypes from "~/API";
import { useTranslation } from "react-i18next";
import { COLORS } from "~/utils";

export const TenantStatusTag = ({
  status,
}: {
  status: APITypes.TenantStatusType;
}) => {
  const { t } = useTranslation();
  let color = COLORS.grey;

  if (status === APITypes.TenantStatusType.Active) {
    color = COLORS.vibrant_green;
  }

  return <Tag color={color}>{t(status as any)}</Tag>;
};
